module.exports = __webpack_public_path__ + "img/service.ead58dd6.png";